import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CredibilitySection } from '../components/CredibilitySection';
import { DiagnosticoSection } from '../components/DiagnosticoSection';
import { SistemaACESection } from '../components/SistemaACESection';
import { ContactFormSection } from '../components/ContactFormSection';
import { CTAFinalSection } from '../components/CTAFinalSection';
import { FooterSection } from '../components/FooterSection';
export function LandingPage() {
  return <main className="min-h-screen bg-carbon flex flex-col w-full overflow-x-hidden" data-id="element-196">
      <HeroSection data-id="element-197" />
      <CredibilitySection data-id="element-198" />
      <DiagnosticoSection data-id="element-199" />
      <SistemaACESection data-id="element-200" />
      <ContactFormSection data-id="element-201" />
      <CTAFinalSection data-id="element-202" />
      <FooterSection data-id="element-203" />
    </main>;
}